import React, { useEffect, useState } from "react";
import { Music, VolumeX } from "lucide-react";
import ambient from "@/lib/ambientAudio";

// Plays the given looping track as soft background music, with a mute toggle.
export const AmbientMusic = ({ src }) => {
  const [muted, setMuted] = useState(ambient.muted);

  useEffect(() => {
    const unsub = ambient.subscribe(() => setMuted(ambient.muted));
    const kick = () => { ambient.setTrack(src); cleanup(); };
    const cleanup = () => {
      document.removeEventListener("pointerdown", kick);
      document.removeEventListener("keydown", kick);
    };
    // set the room's track; browsers need a user gesture before audio starts
    ambient.setTrack(src);
    document.addEventListener("pointerdown", kick);
    document.addEventListener("keydown", kick);
    return () => { unsub(); cleanup(); };
  }, [src]);

  return (
    <button
      data-testid="ambient-toggle"
      onClick={() => ambient.toggle()}
      title={muted ? "Play background music" : "Mute background music"}
      className="fixed bottom-3 left-3 z-50 flex h-11 w-11 items-center justify-center rounded-full border-2 border-kirana-brown bg-kirana-cream/95 text-kirana-brown hard-shadow-sm transition-transform hover:scale-105"
    >
      {muted ? <VolumeX className="h-5 w-5" /> : <Music className="h-5 w-5 animate-pulse" />}
    </button>
  );
};
